const getCandidateLastName = ({ name }) => {
    if (name) {
        const trimmedName = name.trim().replace(/ +(?= )/g, '');
        const nameParts = trimmedName.split(' ');
        if (nameParts.length > 1) {
            const lastNameIndex = nameParts.length - 1;
            const lastName = nameParts[lastNameIndex];
            return lastName;
        }
    }
    return '';
};

const getCandidateFirstName = ({ name }) => {
    if (name) {
        const nameArr = name
            .trim()
            .replace(/ +(?= )/g, '')
            .split(' ');
        return nameArr[0];
    }
    return '';
};

const toLocaleCapitalize = (str, locale) => {
    if (!str) return str;

    const isTurkish = locale === 'tr' || locale === 'tr-TR' || (locale && locale.toLowerCase().includes('tr'));

    if (isTurkish) {
        return str.replace(/[a-zA-ZçğıöşüÇĞIİÖŞÜ][a-zA-ZçğıöşüÇĞIİÖŞÜ\s]*/g, function (txt) {
            const firstChar = txt.charAt(0);
            const restOfString = txt.substr(1);

            const turkishMap = {
                'i': 'İ',
                'ı': 'I',
                'ş': 'Ş',
                'ç': 'Ç',
                'ğ': 'Ğ',
                'ü': 'Ü',
                'ö': 'Ö',
            };

            const capitalizedFirstChar = turkishMap[firstChar] || firstChar.toUpperCase();
            return capitalizedFirstChar + restOfString.toLowerCase();
        });
    }

    return str.replace(/\w\S*/g, function (txt) {
        const firstChar = txt.charAt(0);
        const restOfString = txt.substr(1);
        return firstChar.toUpperCase() + restOfString.toLowerCase();
    });
};

export {
    getCandidateLastName,
    getCandidateFirstName,
    toLocaleCapitalize
}